import React, { useEffect, useState } from 'react'
import styled from './CustomerNotePopup.module.css'
import axios from 'axios'
import useAccountStore from '../stores/account'
import { BASEURL } from '../config'

// 수첩정보 팝업
const CustomerNotePopup = (props:any) => {
    const { popRef, data, showNotePopup, setShowNotePopup, coordinates } = props

    const {accessToken} = useAccountStore()
    const [history, setHistory] = useState<any[]>([])

    useEffect(()=>{
        const fetchUserHistory = async (userID :number) => {
            // setLoading(true) // 로딩 시작
            try {
                await axios.get(`${BASEURL}/esti/history`, {params: { user_id: userID } ,headers: {Authorization: `Bearer ${accessToken}`, }})
                .then(response => response.data)
                .then(obj => {
                    if(obj.status === "success") { setHistory(obj.data) }
                    else { setHistory([]) }
                })
                
            } catch (error:any) {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 401) console.log("토큰이 만료되었습니다.")
                    if(error.response.status === 403) console.log("토큰이 유효하지 않습니다.")
                    if(error.response.status === 404) console.log("사용자 정보를 찾을 수 없습니다.")
                }
            } finally {
                // setLoading(false) // 로딩 종료
            }
        };

        if (data?.userID) { fetchUserHistory(data?.userID) }
    },[data])

    const formatDateToYYYYMMDD = (date:any) => {
        if (!date) return ""
      
        const d = new Date(date)
        const year = d.getFullYear()
        const month = (`0${d.getMonth() + 1}`).slice(-2) // 월은 0부터 시작하므로 1을 더해줍니다.
        const day = (`0${d.getDate()}`).slice(-2)
      
        return `${year}.${month}.${day}`
    }

    return (
        <div className={styled.customer_note_pop}
            ref={popRef}
            style={{ 
            top: `${coordinates.top}px`, 
            left: `${coordinates.left}px`, 
            display: showNotePopup ? 'block' : 'none' }}>
            <p className={styled.tit}>
                <span className={styled.name}>{data?.petName ?? "쿠마"}</span>의 수첩정보
                <a href="#" className={styled.close_btn} onClick={()=>setShowNotePopup(false)}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M8.94028 7.99988L13.1403 3.80655C13.2658 3.68101 13.3363 3.51075 13.3363 3.33321C13.3363 3.15568 13.2658 2.98542 13.1403 2.85988C13.0147 2.73434 12.8445 2.66382 12.667 2.66382C12.4894 2.66382 12.3192 2.73434 12.1936 2.85988L8.00029 7.05988L3.80695 2.85988C3.68142 2.73434 3.51115 2.66382 3.33362 2.66382C3.15608 2.66382 2.98582 2.73434 2.86028 2.85988C2.73475 2.98542 2.66422 3.15568 2.66422 3.33321C2.66422 3.51075 2.73475 3.68101 2.86028 3.80655L7.06029 7.99988L2.86028 12.1932C2.7978 12.2552 2.7482 12.3289 2.71436 12.4102C2.68051 12.4914 2.66309 12.5785 2.66309 12.6665C2.66309 12.7546 2.68051 12.8417 2.71436 12.9229C2.7482 13.0042 2.7978 13.0779 2.86028 13.1399C2.92226 13.2024 2.99599 13.252 3.07723 13.2858C3.15847 13.3197 3.24561 13.3371 3.33362 13.3371C3.42163 13.3371 3.50876 13.3197 3.59 13.2858C3.67124 13.252 3.74498 13.2024 3.80695 13.1399L8.00029 8.93988L12.1936 13.1399C12.2556 13.2024 12.3293 13.252 12.4106 13.2858C12.4918 13.3197 12.5789 13.3371 12.667 13.3371C12.755 13.3371 12.8421 13.3197 12.9233 13.2858C13.0046 13.252 13.0783 13.2024 13.1403 13.1399C13.2028 13.0779 13.2524 13.0042 13.2862 12.9229C13.3201 12.8417 13.3375 12.7546 13.3375 12.6665C13.3375 12.5785 13.3201 12.4914 13.2862 12.4102C13.2524 12.3289 13.2028 12.2552 13.1403 12.1932L8.94028 7.99988Z" fill="black"/>
                </svg></a>
            </p>
            <span>기본정보</span>
            <div className={styled.default_info}>
                <table className="tg">
                    <tbody>
                    <tr>
                        <th>반려동물</th>
                        <td className={styled.name}>{data?.petName ?? "쿠마"}</td>
                        <th>나이</th>
                        <td className={styled.age}>{`${data?.petAge ?? 0}개월`}</td>    
                    </tr>
                    <tr>
                        <th>성별</th>
                        <td className={styled.gender}>{data?.petGender ?? 0}</td>
                        <th>무게</th>
                        <td className={styled.weight}>{data?.petWeight ?? 0}kg</td>
                    </tr>
                    <tr>
                        <th>보호자</th>
                        <td className={styled.gurdian} colSpan={3}>{data?.guardianName ?? "홍길동"}</td>
                    </tr>
                    <tr>
                        <th>전화번호</th>
                        <td className={styled.phone} colSpan={3}>{data?.guardianPhoneNumber ?? "010-1234-5678"}</td>
                    </tr>
                    </tbody>
                    </table>
            </div>
            <span>완료내역</span>
            <div className={styled.history}>
                { history.length > 0 ? (
                <ul>
                    {history.map((item, idx) => (
                        <li key={idx}>
                            <span className={styled.date}>
                                {formatDateToYYYYMMDD(item?.createdAt) ?? "00.00.00"}
                            </span>
                            <span className={styled.his_con}>
                                {item.title ?? item.description ?? "No title"}
                            </span>
                        </li>
                    ))}
                </ul>) 
                : (<div>히스토리가 없습니다.</div>)}
            </div>
        </div>
    )
}

export default CustomerNotePopup